export default __webpack_public_path__ + "da67ca8c38ef44c4773d1183fb7d1149.ttf";